import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ConfirmDialog } from 'primeng/confirmdialog';
import { ButtonModule } from 'primeng/button';
import { Version } from '../../models/version.model';
import { VersionService } from '../../services/version.service';

@Component({
  selector: 'changelog-editor-version-list',
  imports: [CommonModule, ConfirmDialog, ButtonModule],
  templateUrl: './version-list.component.html',
  styleUrl: './version-list.component.css',
  providers: [ConfirmationService]
})
export class VersionListComponent implements OnInit {
  versions: Version[] = [];
  loading = false;

  constructor(
    private versionService: VersionService,
    private router: Router,
    private route: ActivatedRoute,
    private confirmationService: ConfirmationService,
    private messageService: MessageService
  ) {}

  ngOnInit(): void {
    this.loadVersions();
  }

  loadVersions(): void {
    this.loading = true;
    this.versionService.getAllVersions().subscribe({
      next: (versions) => {
        this.versions = versions.sort((a, b) => {
          if (a.major !== b.major) return b.major - a.major;
          if (a.minor !== b.minor) return b.minor - a.minor;
          return b.patch - a.patch;
        });
        this.loading = false;
      },
      error: (error) => {
        console.error('Error loading versions:', error);
        this.loading = false;
      }
    });
  }

  addVersion(): void {
    this.router.navigate(['version/new'], { relativeTo: this.route });
  }

  editVersion(id: string | undefined): void {
    if (id) {
      this.router.navigate(['version', id], { relativeTo: this.route });
    }
  }

  deleteVersion(version: Version): void {
    if (!version.id) return;
    const versionNumber = `${version.major}.${version.minor}.${version.patch}`;
    this.confirmationService.confirm({
      header: 'Delete Version',
      message: `Are you sure you want to delete version ${versionNumber}?`,
      accept: () => {
        this.versionService.deleteVersion(version.id!).subscribe({
          next: () => { this.loadVersions(); },
          error: (error) => {
            console.error('Error deleting version:', error);
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error deleting version. Please try again.' });
          }
        });
      }
    });
  }

  getVersionNumber(version: Version): string {
    return `${version.major}.${version.minor}.${version.patch}`;
  }

  getRolesDisplay(roles: string[]): string {
    return roles.join(', ');
  }

  formatDate(date: Date | undefined): string {
    if (!date) return 'N/A';
    return new Date(date).toLocaleDateString();
  }
}
